module.exports = __webpack_public_path__ + "img/Influencer_Charts.ed0634f6.png";